import { EXPIRY_LOGIN_POP_UP_OPEN, EXPIRY_LOGIN_POP_UP_CLOSE } from '../../constant';
export const expiryLoginPopUpOpen = (warnLostMsg) => ({
  type: EXPIRY_LOGIN_POP_UP_OPEN,
  warnLostMsg: warnLostMsg ?? false,
});

export const expiryLoginPopUpClose = () => ({
  type: EXPIRY_LOGIN_POP_UP_CLOSE,
});
